import { useMutation } from '@tanstack/react-query';
import type { CourseSummary } from '@admitly/shared';
import { apiPost } from '../lib/api.js';

export type SuggestRequest = {
  field?: string;
  category?: string;
  aqf?: string;
  state?: string;
  budgetMaxAud?: number;
  ieltsMax?: number;
  intakeMonth?: number;
  notes?: string;
};

export type SuggestionItem = {
  course: CourseSummary;
  reason: string | null;
};

export type SuggestResponse = {
  aiUsed: boolean;
  items: SuggestionItem[];
  candidateCount: number;
  notice: string | null;
};

/** POST the (course-only) requirements to the AI suggestions endpoint. */
export function useSuggestions() {
  return useMutation<SuggestResponse, Error, SuggestRequest>({
    mutationFn: (req) => apiPost<SuggestResponse>('/suggest', req),
  });
}
